(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloud-cotton-v2-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeReviews(root) {
      if (!root || root.dataset.reviewsInitialized === 'true') return;
      root.dataset.reviewsInitialized = 'true';
      var tabs = Array.from(root.querySelectorAll('[data-review-tab]'));
      var panel = root.querySelector('[data-review-panel]');
      var mount = root.querySelector('[data-review-mount]');
      var status = root.querySelector('[data-review-status]');
      var message = root.querySelector('[data-review-status-message]');
      var fallback = root.querySelector('[data-review-fallback]');
      var fallbackLink = root.querySelector('[data-review-fallback-link]');
      var retry = root.querySelector('[data-review-retry]');
      var heading = root.querySelector('h2');
      var messages;
      try { messages = JSON.parse(root.querySelector('[data-review-messages]').textContent); } catch (error) { return; }
      var currentFamily = root.dataset.reviewFamily;
      var mountedFamily = currentFamily;
      var currentFrame = null;
      var frameLoaded = false;
      var timeout = null;
      var resizeObserver = null;
      var viewportObserver = null;
      var viewportFrame = null;
      var nearViewport = false;
      var demandActive = false;
      var delayed = false;
      var retryUsed = false;
      var observer = new MutationObserver(observeFrame);
      root.dataset.reviewMountedFamily = mountedFamily;
      root.dataset.reviewLoadState = 'waiting';
      retry.hidden = true;

      function activeTab() {
        return tabs.find(function (tab) { return tab.dataset.reviewTab === currentFamily && !tab.disabled; });
      }

      function setDelayed() {
        timeout = null;
        if (!demandActive || mountedFamily !== currentFamily) return;
        delayed = true;
        message.textContent = messages.delayed;
        status.hidden = false;
        fallback.hidden = false;
        retry.hidden = retryUsed || !currentFrame;
        panel.setAttribute('aria-busy', 'false');
        root.dataset.reviewLoadState = 'delayed';
      }

      function checkFrameReady() {
        if (mountedFamily !== currentFamily || !currentFrame || !frameLoaded || currentFrame.getBoundingClientRect().height < 100) return false;
        window.clearTimeout(timeout);
        timeout = null;
        delayed = false;
        status.hidden = true;
        fallback.hidden = true;
        retry.hidden = true;
        panel.setAttribute('aria-busy', 'false');
        root.dataset.reviewLoadState = 'ready';
        return true;
      }

      function onFrameLoad() {
        frameLoaded = true;
        checkFrameReady();
      }

      function observeFrame() {
        var frame = mount.querySelector('iframe');
        if (!frame || frame === currentFrame) return;
        if (currentFrame) currentFrame.removeEventListener('load', onFrameLoad);
        if (resizeObserver) resizeObserver.disconnect();
        currentFrame = frame;
        frameLoaded = false;
        retry.hidden = !delayed || retryUsed;
        frame.addEventListener('load', onFrameLoad);
        if ('ResizeObserver' in window) {
          resizeObserver = new ResizeObserver(checkFrameReady);
          resizeObserver.observe(frame);
        }
        if (window.performance && performance.getEntriesByName(frame.src).some(function (entry) {
          return entry.initiatorType === 'iframe' && entry.responseEnd > 0;
        })) {
          frameLoaded = true;
          checkFrameReady();
        }
      }

      function setLoading(tab) {
        window.clearTimeout(timeout);
        timeout = null;
        delayed = false;
        message.textContent = tab.dataset.reviewLoading;
        fallbackLink.href = tab.dataset.reviewFallbackUrl;
        fallbackLink.textContent = tab.dataset.reviewFallbackLabel;
        status.hidden = false;
        fallback.hidden = true;
        retry.hidden = true;
        panel.setAttribute('aria-busy', 'true');
        root.dataset.reviewLoadState = 'waiting';
      }

      function resetHost(tab) {
        if (currentFrame) currentFrame.removeEventListener('load', onFrameLoad);
        if (resizeObserver) resizeObserver.disconnect();
        currentFrame = null;
        frameLoaded = false;
        var host = document.createElement('div');
        host.id = 'looxReviews';
        host.className = 'loox-reviews-default';
        host.dataset.productId = tab.dataset.reviewProductId;
        host.dataset.limit = '12';
        mountedFamily = tab.dataset.reviewTab;
        root.dataset.reviewMountedFamily = mountedFamily;
        mount.replaceChildren(host);
        setLoading(tab);
      }

      function requestReviews() {
        var tab = activeTab();
        if (!tab) return;
        demandActive = true;
        if (mountedFamily !== currentFamily) resetHost(tab);
        mount.style.visibility = '';
        observeFrame();
        if (checkFrameReady() || delayed || timeout !== null) return;
        root.dataset.reviewLoadState = 'loading';
        timeout = window.setTimeout(setDelayed, 15000);
      }

      function updateViewport() {
        viewportFrame = null;
        var bounds = root.getBoundingClientRect();
        nearViewport = bounds.top <= window.innerHeight + 1000 && bounds.bottom >= -1000;
        if (nearViewport) requestReviews();
        else {
          demandActive = false;
          window.clearTimeout(timeout);
          timeout = null;
          if (root.dataset.reviewLoadState === 'loading') root.dataset.reviewLoadState = 'waiting';
        }
      }

      function scheduleViewportUpdate() {
        if (viewportFrame === null) viewportFrame = window.requestAnimationFrame(updateViewport);
      }

      function select(family, options) {
        var tab = tabs.find(function (item) { return item.dataset.reviewTab === family && !item.disabled; });
        if (!tab || !/^\d+$/.test(tab.dataset.reviewProductId || '')) return false;
        var changed = currentFamily !== family;
        currentFamily = family;
        root.dataset.reviewFamily = family;
        tabs.forEach(function (item) {
          var selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panel.setAttribute('aria-labelledby', tab.id);
        if (changed) {
          setLoading(tab);
          mount.style.visibility = mountedFamily === currentFamily ? '' : 'hidden';
          checkFrameReady();
        }
        if (options && options.retry) {
          if (retryUsed || !delayed || !currentFrame || mountedFamily !== currentFamily) return false;
          retryUsed = true;
          resetHost(tab);
        }
        if (nearViewport || options && (options.demand || options.scroll || options.retry)) requestReviews();
        if (options && options.scroll) {
          root.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          heading.focus({ preventScroll: true });
        }
        return true;
      }

      function onFamilyChange(event) {
        if (event.detail) select(event.detail.family, { scroll: false });
      }

      function onShowReviews(event) {
        if (event.detail) select(event.detail.family, { scroll: true });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { select(tab.dataset.reviewTab, { demand: true }); });
        tab.addEventListener('keydown', function (event) {
          var enabledTabs = tabs.filter(function (item) { return !item.disabled; });
          var index = enabledTabs.indexOf(tab);
          if (event.key === 'ArrowRight') index = (index + 1) % enabledTabs.length;
          else if (event.key === 'ArrowLeft') index = (index - 1 + enabledTabs.length) % enabledTabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = enabledTabs.length - 1;
          else return;
          event.preventDefault();
          enabledTabs[index].focus();
          select(enabledTabs[index].dataset.reviewTab, { demand: true });
        });
      });
      retry.addEventListener('click', function () { select(currentFamily, { retry: true }); });
      document.addEventListener('ccv4:family-change', onFamilyChange);
      document.addEventListener('ccv4:show-reviews', onShowReviews);
      window.ccv4ProductReviews = { select: select };
      observer.observe(mount, { childList: true, subtree: true });
      var initialTab = activeTab();
      if (initialTab) {
        setLoading(initialTab);
        observeFrame();
      } else {
        message.textContent = messages.unavailable;
        panel.setAttribute('aria-busy', 'false');
      }
      var builder = document.querySelector('[data-ccv2][data-family]');
      if (builder) select(builder.dataset.family);
      if ('IntersectionObserver' in window) {
        viewportObserver = new IntersectionObserver(updateViewport, { rootMargin: '1000px 0px' });
        viewportObserver.observe(root);
      } else {
        window.addEventListener('scroll', scheduleViewportUpdate, { passive: true });
      }
      window.addEventListener('resize', scheduleViewportUpdate, { passive: true });
      updateViewport();

      function onSectionUnload(event) {
        if (!event.detail || event.detail.sectionId !== root.dataset.sectionId) return;
        window.clearTimeout(timeout);
        if (viewportFrame !== null) window.cancelAnimationFrame(viewportFrame);
        observer.disconnect();
        if (viewportObserver) viewportObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        if (currentFrame) currentFrame.removeEventListener('load', onFrameLoad);
        document.removeEventListener('ccv4:family-change', onFamilyChange);
        document.removeEventListener('ccv4:show-reviews', onShowReviews);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        window.removeEventListener('scroll', scheduleViewportUpdate);
        window.removeEventListener('resize', scheduleViewportUpdate);
        if (window.ccv4ProductReviews && window.ccv4ProductReviews.select === select) delete window.ccv4ProductReviews;
      }
      document.addEventListener('shopify:section:unload', onSectionUnload);
    }

    function initializeAllReviews() {
      document.querySelectorAll('[data-ccv2-product-reviews]').forEach(initializeReviews);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAllReviews);
    else initializeAllReviews();
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) initializeReviews(event.target.querySelector('[data-ccv2-product-reviews]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloud-cotton-v4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SIZE_ORDER = ['Small', 'Medium', 'Large', 'X-Large', '2XL', '3XL'];
    var SIZE_LABELS = { Small: 'S', Medium: 'M', Large: 'L', 'X-Large': 'XL', '2XL': '2X', '3XL': '3X' };
    var FAMILY_LABELS = { hoodie: 'Hoodie', zipper: 'Full-Zip Zipper' };
    var COLOR_PRIORITY = {
      hoodie: ['Berry Crush', 'Lavender Twilight', 'Rainbow Love', 'Jet Black', 'Shark Steel Blue', 'Amethyst', 'Periwinkle Pixie Dust', 'Bubble Gum', 'Mermaid Dream', 'Desert Sky', 'Dijon Mustard Yellow', 'Grape Juice', 'Frozen Blue', 'Ocean Mint'],
      zipper: ['Bubble Gum', 'Amethyst', 'Shark Steel Blue', 'Periwinkle Pixie Dust', 'Jet Black']
    };

    function money(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
    }

    function imageUrl(value) {
      var source = value || '';
      if (typeof source === 'object') {
        source = source.src || (source.preview_image && source.preview_image.src) || '';
      }
      if (source && source.indexOf('//') === 0) source = 'https:' + source;
      return source;
    }

    function variantImage(variant, product) {
      return imageUrl(variant && (variant.featured_image || variant.featured_media)) || imageUrl(product && product.featured_image);
    }

    function variantOptions(variant) {
      if (variant && Array.isArray(variant.options)) return variant.options;
      return [variant && variant.option1, variant && variant.option2, variant && variant.option3].filter(Boolean);
    }

    function key(color, size) {
      return String(color || '') + '||' + String(size || '');
    }

    function indexVariants(product) {
      var map = new Map();
      if (!product || !Array.isArray(product.variants)) return map;
      product.variants.forEach(function (variant) {
        var options = variantOptions(variant);
        if (options.length >= 2) map.set(key(options[1], options[0]), variant);
      });
      return map;
    }

    function productColors(product) {
      var values = [];
      if (!product || !Array.isArray(product.variants)) return values;
      product.variants.forEach(function (variant) {
        var options = variantOptions(variant);
        var color = options[1];
        if (color && values.indexOf(color) === -1) values.push(color);
      });
      return values;
    }

    function buildFamily(raw, familyKey) {
      var main = raw && raw.main;
      var preorder = raw && raw.preorder;
      var mainMap = indexVariants(main);
      var preorderMap = indexVariants(preorder);
      var colors = productColors(main).concat(productColors(preorder).filter(function (color) { return productColors(main).indexOf(color) === -1; }));
      var priority = COLOR_PRIORITY[familyKey] || [];
      colors.sort(function (a, b) {
        var ai = priority.indexOf(a);
        var bi = priority.indexOf(b);
        if (ai === -1) ai = 999;
        if (bi === -1) bi = 999;
        return ai - bi;
      });
      var cells = {};
      colors.forEach(function (color) {
        cells[color] = {};
        SIZE_ORDER.forEach(function (size) {
          var mainVariant = mainMap.get(key(color, size));
          var preorderVariant = preorderMap.get(key(color, size));
          var chosen = null;
          var state = 'soldout';
          if (mainVariant && mainVariant.available) {
            chosen = mainVariant;
            state = 'instock';
          } else if (preorderVariant && preorderVariant.available) {
            chosen = preorderVariant;
            state = 'preorder';
          }
          var image = variantImage(mainVariant, main) || variantImage(preorderVariant, preorder);
          cells[color][size] = {
            state: state,
            id: chosen ? chosen.id : null,
            price: chosen ? chosen.price : ((mainVariant && mainVariant.price) || (preorderVariant && preorderVariant.price) || (main && main.price) || (preorder && preorder.price) || 0),
            compareAt: chosen ? chosen.compare_at_price : ((mainVariant && mainVariant.compare_at_price) || (preorderVariant && preorderVariant.compare_at_price) || (main && main.compare_at_price) || (preorder && preorder.compare_at_price) || 0),
            image: image,
            mainVariantId: mainVariant ? mainVariant.id : null,
            preorderDate: raw && raw.preorderDate,
            sourceHandle: state === 'preorder' && preorder ? preorder.handle : (main && main.handle)
          };
        });
      });
      var fullyInStock = colors.find(function (color) {
        return SIZE_ORDER.every(function (size) { return cells[color][size].state === 'instock'; });
      });
      var defaultColor = fullyInStock || colors.find(function (color) {
        return SIZE_ORDER.some(function (size) { return cells[color][size].state !== 'soldout'; });
      }) || colors[0];
      return {
        key: familyKey,
        label: FAMILY_LABELS[familyKey],
        main: main,
        preorder: preorder,
        colors: colors,
        cells: cells,
        defaultColor: defaultColor
      };
    }

    function firstSellableSize(family, color, preferred) {
      var ordered = preferred ? [preferred].concat(['Medium', 'Large', 'Small', 'X-Large', '2XL', '3XL'].filter(function (item) { return item !== preferred; })) : ['Medium', 'Large', 'Small', 'X-Large', '2XL', '3XL'];
      return ordered.find(function (size) {
        return family.cells[color] && family.cells[color][size] && family.cells[color][size].state !== 'soldout';
      }) || SIZE_ORDER[0];
    }

    function createButton(label, className, pressed) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.setAttribute('aria-pressed', String(Boolean(pressed)));
      button.textContent = label;
      return button;
    }

    function init(root) {
      if (root.dataset.ccv4Ready === 'true') return;
      root.dataset.ccv4Ready = 'true';
      var dataNode = root.querySelector('[data-ccv4-data]');
      if (!dataNode) return;
      var data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (error) {
        root.dataset.ccv4Error = 'data';
        return;
      }
      var families = {
        hoodie: buildFamily(data.products.hoodie, 'hoodie'),
        zipper: buildFamily(data.products.zipper, 'zipper')
      };
      var state = {
        offer: 'two',
        first: { family: 'hoodie', color: families.hoodie.defaultColor, size: '' },
        second: null,
        gift: null,
        busy: false
      };
      state.first.size = firstSellableSize(families.hoodie, state.first.color, 'Medium');
      var lastFocus = null;
      var toastTimer = null;

      function q(selector) { return root.querySelector(selector); }
      function qa(selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
      function familyFor(selection) { return families[selection.family]; }
      function cellFor(selection) {
        var family = familyFor(selection);
        return family && family.cells[selection.color] && family.cells[selection.color][selection.size];
      }
      function currentPrice(selection) {
        var cell = cellFor(selection);
        return Number(cell && cell.price || 0);
      }
      function currentCompare(selection) {
        var cell = cellFor(selection);
        return Number(cell && cell.compareAt || 0);
      }
      function selectedImage(selection) {
        var cell = cellFor(selection);
        if (cell && cell.image) return cell.image;
        var family = familyFor(selection);
        var sizes = family && family.cells[selection.color];
        if (!sizes) return '';
        var found = SIZE_ORDER.map(function (size) { return sizes[size]; }).find(function (item) { return item && item.image; });
        return found ? found.image : '';
      }
      function ensureValid(selection) {
        var family = familyFor(selection);
        if (!family) return;
        if (!selection.color || !family.cells[selection.color]) selection.color = family.defaultColor;
        var cell = family.cells[selection.color] && family.cells[selection.color][selection.size];
        if (!cell || cell.state === 'soldout') selection.size = firstSellableSize(family, selection.color, selection.size);
      }
      function imageWithWidth(src, width) {
        try {
          var url = new URL(src, window.location.href);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch (error) {
          return src;
        }
      }
      function setImage(node, src, alt) {
        if (!node) return;
        if (src) {
          var widths = node.classList.contains('ccv4__sticky-image') ? [120] : [360, 540, 720, 960, 1200];
          node.src = imageWithWidth(src, widths[widths.length - 1]);
          node.srcset = widths.map(function (width) { return imageWithWidth(src, width) + ' ' + width + 'w'; }).join(', ');
          node.sizes = node.classList.contains('ccv4__sticky-image') ? '60px' : '(min-width: 900px) 52vw, 100vw';
        }
        node.alt = alt || '';
      }
      function productName(selection) {
        return selection.family === 'zipper' ? 'Cloud Cotton Zipper' : 'Cloud Cotton Hoodie';
      }
      function selectionDetail(selection) {
        var cell = cellFor(selection);
        var detail = selection.color + ' / ' + selection.size;
        if (cell && cell.state === 'preorder') detail += ' · Pre-order';
        return detail;
      }
      function showToast(message) {
        var node = q('[data-toast]');
        if (!node) return;
        window.clearTimeout(toastTimer);
        node.textContent = message;
        node.classList.add('is-visible');
        toastTimer = window.setTimeout(function () { node.classList.remove('is-visible'); }, 3200);
      }

      function renderFamilyOptions() {
        var container = q('[data-family-options]');
        if (!container) return;
        container.innerHTML = '';
        ['hoodie', 'zipper'].forEach(function (familyKey) {
          var family = families[familyKey];
          var price = 0;
          var color = family.defaultColor;
          var size = firstSellableSize(family, color, 'Medium');
          if (family.cells[color] && family.cells[color][size]) price = family.cells[color][size].price;
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'ccv4__style-option';
          button.dataset.family = familyKey;
          button.setAttribute('aria-pressed', String(state.first.family === familyKey));
          var top = document.createElement('span');
          var name = document.createElement('strong');
          name.textContent = familyKey === 'hoodie' ? 'Pullover Hoodie' : 'Full-Zip Zipper';
          var amount = document.createElement('b');
          amount.textContent = money(price);
          top.append(name, amount);
          var states = [];
          family.colors.forEach(function (familyColor) {
            SIZE_ORDER.forEach(function (familySize) {
              var familyCell = family.cells[familyColor] && family.cells[familyColor][familySize];
              if (familyCell && states.indexOf(familyCell.state) === -1) states.push(familyCell.state);
            });
          });
          var note = document.createElement('small');
          if (states.indexOf('instock') !== -1 && states.indexOf('preorder') !== -1) note.textContent = 'In-stock + pre-order sizes';
          else if (states.indexOf('instock') !== -1) note.textContent = 'In stock';
          else if (states.indexOf('preorder') !== -1) note.textContent = 'Currently pre-order';
          else note.textContent = 'Currently unavailable';
          button.append(top, note);
          button.addEventListener('click', function () {
            if (state.first.family === familyKey) return;
            var oldColor = state.first.color;
            var oldSize = state.first.size;
            state.first.family = familyKey;
            state.first.color = family.cells[oldColor] ? oldColor : family.defaultColor;
            state.first.size = firstSellableSize(family, state.first.color, oldSize);
            render();
            window.requestAnimationFrame(function () {
              var replacement = q('[data-family="' + familyKey + '"]');
              if (replacement) replacement.focus();
            });
          });
          container.append(button);
        });
      }

      function renderColors() {
        var container = q('[data-color-options]');
        if (!container) return;
        container.innerHTML = '';
        var family = familyFor(state.first);
        family.colors.forEach(function (color) {
          var sample = SIZE_ORDER.map(function (size) { return family.cells[color][size]; }).find(function (item) { return item && item.image; });
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'ccv4__swatch';
          button.dataset.ssRole = 'swatch';
          button.dataset.colorSlug = color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
          button.title = color;
          button.setAttribute('aria-label', color);
          button.setAttribute('aria-pressed', String(state.first.color === color));
          var image = document.createElement('img');
          image.src = sample && sample.image || '';
          image.alt = '';
          image.loading = 'lazy';
          image.width = 40;
          image.height = 40;
          button.append(image);
          button.addEventListener('click', function () {
            if (state.first.color === color) return;
            state.first.color = color;
            state.first.size = firstSellableSize(family, color, state.first.size);
            render();
            window.requestAnimationFrame(function () {
              var replacement = q('[data-color-slug="' + button.dataset.colorSlug + '"]');
              if (replacement) replacement.focus();
            });
          });
          container.append(button);
        });
      }

      function renderSizes() {
        var container = q('[data-size-options]');
        if (!container) return;
        container.innerHTML = '';
        var family = familyFor(state.first);
        SIZE_ORDER.forEach(function (size) {
          var cell = family.cells[state.first.color] && family.cells[state.first.color][size];
          var button = createButton(SIZE_LABELS[size], 'ccv4__size', state.first.size === size);
          button.dataset.ssRole = 'size';
          button.dataset.size = size;
          button.dataset.variantId = cell && cell.id || '';
          button.disabled = !cell || cell.state === 'soldout';
          if (cell && cell.state === 'preorder') {
            var note = document.createElement('small');
            note.textContent = 'Pre-order';
            button.append(note);
          }
          button.addEventListener('click', function () {
            if (!cell || cell.state === 'soldout') return;
            state.first.size = size;
            render();
            window.requestAnimationFrame(function () {
              var replacement = q('[data-size="' + size + '"]');
              if (replacement) replacement.focus();
            });
          });
          container.append(button);
        });
      }

      function renderHero() {
        var cell = cellFor(state.first);
        var price = currentPrice(state.first);
        var compare = currentCompare(state.first);
        var savings = Math.max(0, compare - price);
        var percent = compare ? Math.round(savings / compare * 100) : 0;
        var headline = state.first.family === 'hoodie' ? data.copy.hoodieHeadline : data.copy.zipperHeadline;
        var subtitle = state.first.family === 'hoodie' ? data.copy.hoodieSubtitle : data.copy.zipperSubtitle;
        var headlineNode = q('[data-product-headline]');
        var subtitleNode = q('[data-product-subtitle]');
        var styleName = q('[data-style-name]');
        var colorName = q('[data-color-name]');
        if (headlineNode) headlineNode.textContent = headline;
        if (subtitleNode) subtitleNode.textContent = subtitle;
        if (styleName) styleName.textContent = FAMILY_LABELS[state.first.family];
        if (colorName) colorName.textContent = state.first.color;
        var compareNode = q('[data-compare-price]');
        var priceNode = q('[data-sale-price]');
        var saveNode = q('[data-save-pill]');
        if (compareNode) compareNode.textContent = money(compare);
        if (priceNode) priceNode.textContent = money(price);
        if (saveNode) saveNode.textContent = savings ? 'SAVE ' + money(savings).replace('.00', '') + ' · ' + percent + '% OFF' : '';
        var one = q('[data-one-price]');
        var two = q('[data-two-price]');
        if (one) one.textContent = money(price);
        if (two) two.textContent = money(price * 2);
        var mainImage = q('.ccv4__main-image');
        setImage(mainImage, selectedImage(state.first), productName(state.first) + ' in ' + state.first.color);
        var status = q('[data-selection-status]');
        if (status) {
          if (cell && cell.state === 'preorder') {
            status.innerHTML = '<strong>Pre-order</strong>' + (cell.preorderDate ? ' · estimated to ship ' + cell.preorderDate : '');
          } else if (cell && cell.state === 'instock') {
            status.innerHTML = '<strong>In stock</strong> · ready to ship';
          } else {
            status.textContent = 'Choose another size';
          }
        }
      }

      function renderOffer() {
        qa('[data-offer]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.offer === state.offer));
          button.dataset.ssRole = 'pack';
          button.dataset.pack = button.dataset.offer === 'two' ? '2' : '1';
        });
        var price = currentPrice(state.first);
        var action = state.offer === 'one' ? 'ADD TO CART · ' + money(price) : ((state.second ? 'REVIEW 2 ITEMS · ' : 'CHOOSE ITEM 2 · ') + money(price * 2));
        var primary = q('[data-primary-action]');
        var sticky = q('[data-sticky-action]');
        if (primary) primary.textContent = action;
        if (sticky) sticky.textContent = state.offer === 'one' ? 'ADD TO CART' : (state.second ? 'REVIEW 2 ITEMS' : 'CHOOSE ITEM 2');
      }

      function renderSticky() {
        var image = q('.ccv4__sticky-image');
        var price = q('[data-sticky-price]');
        var detail = q('[data-sticky-detail]');
        setImage(image, selectedImage(state.first), '');
        if (price) price.textContent = money(currentPrice(state.first));
        if (detail) detail.textContent = FAMILY_LABELS[state.first.family] + ' · ' + state.first.color + ' · ' + SIZE_LABELS[state.first.size];
      }

      function summaryMarkup(selection, itemNumber) {
        return '<img src="' + selectedImage(selection).replace(/"/g, '&quot;') + '" alt="" width="50" height="50"><div><h3>Item ' + itemNumber + ' · ' + productName(selection) + '</h3><p>' + selectionDetail(selection) + '</p></div><strong>' + money(currentPrice(selection)) + '</strong>';
      }

      function cloneFirstForSecond() {
        if (!state.second) {
          state.second = { family: state.first.family, color: state.first.color, size: state.first.size };
          ensureValid(state.second);
        }
      }

      function renderSecondBuilder() {
        cloneFirstForSecond();
        var firstSummary = q('[data-first-summary]');
        var secondSummary = q('[data-second-summary]');
        if (firstSummary) firstSummary.innerHTML = summaryMarkup(state.first, 1);
        if (secondSummary) secondSummary.innerHTML = summaryMarkup(state.second, 2);
        var familyContainer = q('[data-second-families]');
        if (familyContainer) {
          familyContainer.innerHTML = '';
          ['hoodie', 'zipper'].forEach(function (familyKey) {
            var button = createButton(FAMILY_LABELS[familyKey], '', state.second.family === familyKey);
            button.addEventListener('click', function () {
              var family = families[familyKey];
              var oldColor = state.second.color;
              var oldSize = state.second.size;
              state.second.family = familyKey;
              state.second.color = family.cells[oldColor] ? oldColor : family.defaultColor;
              state.second.size = firstSellableSize(family, state.second.color, oldSize);
              state.gift = null;
              renderSecondBuilder();
              renderOffer();
              window.requestAnimationFrame(function () {
                var replacement = q('[data-second-families] button[aria-pressed="true"]');
                if (replacement) replacement.focus();
              });
            });
            familyContainer.append(button);
          });
        }
        var colorSelect = q('[data-second-color]');
        var sizeSelect = q('[data-second-size]');
        var family = familyFor(state.second);
        if (colorSelect) {
          colorSelect.innerHTML = '';
          family.colors.forEach(function (color) {
            var option = document.createElement('option');
            option.value = color;
            option.textContent = color;
            option.selected = color === state.second.color;
            colorSelect.append(option);
          });
        }
        if (sizeSelect) {
          sizeSelect.innerHTML = '';
          SIZE_ORDER.forEach(function (size) {
            var cell = family.cells[state.second.color] && family.cells[state.second.color][size];
            var option = document.createElement('option');
            option.value = size;
            option.disabled = !cell || cell.state === 'soldout';
            option.selected = size === state.second.size;
            option.textContent = SIZE_LABELS[size] + (cell && cell.state === 'preorder' ? ' · Pre-order' : (cell && cell.state === 'soldout' ? ' · Sold out' : ' · In stock'));
            sizeSelect.append(option);
          });
        }
        renderGift();
        var submit = q('[data-submit-two]');
        if (submit) submit.textContent = 'ADD 2 ITEMS TO CART · ' + money(currentPrice(state.first) + currentPrice(state.second));
      }

      function mysteryVariant(size) {
        var mystery = data.products.mystery;
        if (!mystery || !Array.isArray(mystery.variants)) return null;
        return mystery.variants.find(function (variant) {
          var options = variantOptions(variant);
          return options[0] === size && variant.available;
        }) || null;
      }

      function renderGift() { state.gift = null; }

      function render() {
        ensureValid(state.first);
        renderFamilyOptions();
        renderColors();
        renderSizes();
        renderHero();
        renderOffer();
        renderSticky();
        if (state.second) renderSecondBuilder();
      }

      function openBuilder(opener) {
        cloneFirstForSecond();
        renderSecondBuilder();
        var builder = q('[data-builder]');
        if (!builder) return;
        lastFocus = opener || document.activeElement;
        builder.hidden = false;
        builder.setAttribute('aria-hidden', 'false');
        setModalIsolation(builder);
        document.body.classList.add('ccv4-lock');
        var close = q('.ccv4__builder-close');
        if (close) close.focus();
      }

      function closeBuilder() {
        var builder = q('[data-builder]');
        if (!builder || builder.hidden) return;
        builder.hidden = true;
        builder.setAttribute('aria-hidden', 'true');
        setModalIsolation(null);
        document.body.classList.remove('ccv4-lock');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }

      function lineFor(selection) {
        var family = familyFor(selection);
        var cell = cellFor(selection);
        var line = { id: Number(cell.id), quantity: 1 };
        if (cell.state === 'preorder') {
          line.properties = {
            'Purchase Type': 'Pre-Order',
            'Estimated Ship Date': cell.preorderDate || '',
            '_Parent Product Handle': family.main && family.main.handle || '',
            '_Parent Variant ID': cell.mainVariantId || '',
            'Color': selection.color,
            'Size': selection.size
          };
        }
        return line;
      }

      function coalesce(lines) {
        var result = [];
        lines.forEach(function (line) {
          var signature = String(line.id) + '|' + JSON.stringify(line.properties || {});
          var existing = result.find(function (entry) { return entry.signature === signature; });
          if (existing) existing.line.quantity += line.quantity;
          else result.push({ signature: signature, line: line });
        });
        return result.map(function (entry) { return entry.line; });
      }

      function cartUrl() {
        var base = data.routes.cart || '/cart';
        var source = new URLSearchParams(window.location.search);
        var params = new URLSearchParams();
        source.forEach(function (value, name) {
          if (name.indexOf('utm_') === 0 || name === 'fbclid') params.append(name, value);
        });
        var query = params.toString();
        return base + (query ? '?' + query : '');
      }

      async function submit(items, button, messageNode) {
        if (state.busy) return;
        state.busy = true;
        if (button) button.disabled = true;
        if (messageNode) messageNode.textContent = '';
        var params = new URLSearchParams(window.location.search);
        if (params.get('ccv4_mock') === '1' || params.get('mock') === '1') {
          window.setTimeout(function () {
            state.busy = false;
            if (button) button.disabled = false;
            showToast('Test mode: cart request validated without changing your cart.');
          }, 350);
          return;
        }
        try {
          var rootRoute = data.routes.root || '/';
          var endpoint = data.routes.cartAdd || (rootRoute + 'cart/add');
          if (endpoint.slice(-3) !== '.js') endpoint = endpoint.replace(/\/$/, '') + '.js';
          var response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: coalesce(items) })
          });
          if (!response.ok) throw new Error('Cart request failed');
          if (state.gift) {
            var cart = null;
            try {
              var cartResponse = await fetch(rootRoute + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
              cart = cartResponse.ok ? await cartResponse.json() : null;
            } catch (cartError) {
              cart = null;
            }
            if (!cart || !Array.isArray(cart.items)) {
              if (button) {
                button.disabled = true;
                button.textContent = 'ITEMS ADDED';
              }
              if (messageNode) messageNode.innerHTML = 'Your items were added, but the free-item discount could not be verified. <a href="' + cartUrl() + '">Review your cart.</a>';
              return;
            }
            var giftLine = cart.items.find(function (item) { return Number(item.variant_id) === Number(state.gift.id); });
            if (!giftLine || Number(giftLine.final_line_price) !== 0) {
              if (button) {
                button.disabled = true;
                button.textContent = 'ITEMS ADDED';
              }
              if (messageNode) messageNode.innerHTML = 'Your items were added, but the free-item discount could not be confirmed. <a href="' + cartUrl() + '">Review your cart.</a>';
              return;
            }
          }
          window.location.assign(cartUrl());
        } catch (error) {
          state.busy = false;
          if (button) button.disabled = false;
          if (messageNode) messageNode.textContent = 'Something went wrong adding these items. Please try again.';
        }
      }

      function primaryAction(opener) {
        if (state.offer === 'two') {
          openBuilder(opener);
          return;
        }
        submit([lineFor(state.first)], opener, q('[data-selection-status]'));
      }

      qa('[data-offer]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.offer = button.dataset.offer;
          if (state.offer === 'one') {
            state.second = null;
            state.gift = null;
          }
          render();
        });
      });
      var primary = q('[data-primary-action]');
      var stickyAction = q('[data-sticky-action]');
      if (primary) primary.addEventListener('click', function () { primaryAction(primary); });
      if (stickyAction) stickyAction.addEventListener('click', function () { primaryAction(stickyAction); });
      qa('[data-builder-close]').forEach(function (button) { button.addEventListener('click', closeBuilder); });
      var secondColor = q('[data-second-color]');
      var secondSize = q('[data-second-size]');
      if (secondColor) secondColor.addEventListener('change', function () {
        state.second.color = secondColor.value;
        state.second.size = firstSellableSize(familyFor(state.second), state.second.color, state.second.size);
        state.gift = null;
        renderSecondBuilder();
        renderOffer();
        window.requestAnimationFrame(function () {
          var replacement = q('[data-second-color]');
          if (replacement) replacement.focus();
        });
      });
      if (secondSize) secondSize.addEventListener('change', function () {
        state.second.size = secondSize.value;
        state.gift = null;
        renderSecondBuilder();
        renderOffer();
        window.requestAnimationFrame(function () {
          var replacement = q('[data-second-size]');
          if (replacement) replacement.focus();
        });
      });
      var addGift = q('[data-add-gift]');
      if (addGift) addGift.addEventListener('click', function () {
        var select = q('[data-gift-size]');
        var size = select ? select.value : state.first.size;
        var variant = mysteryVariant(size);
        if (!variant) {
          showToast('That Mystery Item size is unavailable.');
          return;
        }
        state.gift = { id: variant.id, size: size };
        renderGift();
      });
      var giftSize = q('[data-gift-size]');
      if (giftSize) giftSize.addEventListener('change', function () {
        if (state.gift) state.gift = null;
        renderGift();
      });
      var submitTwo = q('[data-submit-two]');
      if (submitTwo) submitTwo.addEventListener('click', function () {
        ensureValid(state.second);
        var lines = [lineFor(state.first), lineFor(state.second)];
        if (state.gift) lines.push({ id: Number(state.gift.id), quantity: 1 });
        submit(lines, submitTwo, q('[data-builder-message]'));
      });
      var scrollButton = q('[data-scroll-to-options]');
      if (scrollButton) scrollButton.addEventListener('click', function () {
        var target = q('.ccv4__style-choice');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      var galleryTrack = q('[data-gallery-track]');
      var galleryDots = qa('[data-gallery-dot]');
      function updateDots(index) {
        galleryDots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
      }
      galleryDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var slide = qa('[data-gallery-slide]')[Number(dot.dataset.galleryDot)];
          if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
      if (galleryTrack) galleryTrack.addEventListener('scroll', function () {
        var width = galleryTrack.getBoundingClientRect().width || 1;
        updateDots(Math.round(galleryTrack.scrollLeft / width));
      }, { passive: true });

      var lightbox = q('[data-lightbox]');
      function closeLightbox() {
        if (!lightbox || lightbox.hidden) return;
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        setModalIsolation(null);
        document.body.classList.remove('ccv4-lock');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }
      qa('[data-lightbox-open]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!lightbox) return;
          var image = button.querySelector('img');
          var target = q('[data-lightbox-image]');
          if (!image || !target) return;
          lastFocus = button;
          target.src = image.currentSrc || image.src;
          target.alt = image.alt;
          lightbox.hidden = false;
          lightbox.setAttribute('aria-hidden', 'false');
          setModalIsolation(lightbox);
          document.body.classList.add('ccv4-lock');
          var close = lightbox.querySelector('.ccv4__lightbox-panel > button');
          if (close) close.focus();
        });
      });
      qa('[data-lightbox-close]').forEach(function (button) { button.addEventListener('click', closeLightbox); });
      function setModalIsolation(activeModal) {
        Array.prototype.slice.call(root.children).forEach(function (child) {
          if (child === activeModal || child === q('[data-toast]')) return;
          if (activeModal) child.setAttribute('inert', '');
          else child.removeAttribute('inert');
        });
      }
      function trapFocus(container, event) {
        var focusable = Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) {
          return node.offsetParent !== null && node.tabIndex >= 0;
        });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
      document.addEventListener('keydown', function (event) {
        var openBuilderNode = q('[data-builder]');
        if (event.key === 'Tab') {
          if (lightbox && !lightbox.hidden) trapFocus(lightbox, event);
          else if (openBuilderNode && !openBuilderNode.hidden) trapFocus(openBuilderNode, event);
          return;
        }
        if (event.key !== 'Escape') return;
        if (lightbox && !lightbox.hidden) closeLightbox();
        else closeBuilder();
      });

      if ('IntersectionObserver' in window && primary) {
        var stickyBar = q('[data-sticky-bar]');
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (stickyBar) {
            stickyBar.classList.toggle('is-visible', visible);
            stickyBar.setAttribute('aria-hidden', String(!visible));
            if (stickyAction) stickyAction.tabIndex = visible ? 0 : -1;
          }
        }, { threshold: 0 });
        observer.observe(primary);
      }
      render();
    }

    function initializeAll(scope) {
      var rootScope = scope || document;
      Array.prototype.slice.call(rootScope.querySelectorAll('[data-ccv4]')).forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
    else initializeAll(document);
    document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-mystery-drop"]) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const strings = JSON.parse(root.querySelector('[data-mystery-strings]').textContent);
    const packs = JSON.parse(root.querySelector('[data-mystery-packs]').textContent);
    const state = {pack:2,size:null,variant:null};
    const result = root.querySelector('.ssm-result');
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency});
    const compactFormatter = new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
    const money = (cents, full = false) => (full || Math.round(cents) % 100 !== 0 ? formatter : compactFormatter).format(Math.round(cents) / 100);
    const fill = (value, replacements) => Object.entries(replacements).reduce((text, [key, entry]) => text.replaceAll('__' + key + '__', String(entry)), value);
    const tokens = (value, replacements) => Object.entries(replacements).reduce((text, [key, entry]) => text.replaceAll('[' + key + ']', String(entry)), value || '');
    const packVariants = pack => packs[pack] || [];
    function quote(pack) {
      const variants = packVariants(pack);
      const available = variants.filter(item => item.available);
      const selected = variants.find(item => item.size === state.size);
      const variant = selected || [...(available.length ? available : variants)].sort((a,b) => a.price - b.price)[0];
      const varies = !selected && new Set(available.map(item => item.price)).size > 1;
      return {variant,varies,available:state.size ? !!selected?.available : available.length > 0};
    }
    const label = (quote, count = 1, full = false) => quote.variant ? (quote.varies ? strings.from + ' ' : '') + money(quote.variant.price / count, full) : '—';
    const shipsFree = quote => root.dataset.shippingEligible === 'true' && Number(root.dataset.shippingThreshold) > 0 && quote.available && quote.variant.price >= Number(root.dataset.shippingThreshold);
    function render() {
      root.querySelectorAll('[data-size]').forEach(button => {
        const variant = packVariants(state.pack).find(item => item.size === button.dataset.sizeName);
        button.disabled = !variant?.available;
        if (button.disabled && button.dataset.sizeName === state.size) state.size = null;
      });
      root.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeName === state.size)));
      const quotes = Object.fromEntries([1,2,3,4].map(pack => [pack,quote(pack)]));
      const current = quotes[state.pack];
      state.variant = packVariants(state.pack).find(item => item.size === state.size && item.available)?.id || null;
      root.querySelectorAll('[data-pack]').forEach(button => {
        const pack = Number(button.dataset.pack), entry = quotes[pack];
        button.setAttribute('aria-pressed', String(pack === state.pack));
        button.disabled = !packVariants(pack).some(item => item.available);
        button.querySelector('[data-pack-price]').textContent = label(entry);
        button.querySelector('[data-pack-unit]').textContent = fill(strings.perPiece, {PRICE:label(entry,pack)});
        button.querySelector('[data-free-shipping]').hidden = !shipsFree(entry);
        if (pack === 4) {
          const best = entry.available && [1,2,3].every(other => !quotes[other].available || entry.variant.price / 4 < quotes[other].variant.price / other);
          button.querySelector('.ssm-pack-tag').hidden = !best;
        }
      });
      root.querySelector('[data-total]').textContent = label(current,1,true);
      root.querySelector('[data-unit]').textContent = fill(strings.unit, {PRICE:label(current,state.pack)});
      root.querySelector('[data-summary]').textContent = state.pack === 1 ? strings.summaryOne : fill(strings.summary, {COUNT:state.pack});
      root.querySelector('[data-savings]').textContent = state.pack === 1 ? strings.oneNote : (shipsFree(current) ? strings.freeShipping + '. ' : '') + tokens(strings.pieceSummary,{price:label(current,state.pack)});
      root.querySelector('[data-shipping-note]').hidden = !shipsFree(current);
      const upgrade = root.querySelector('[data-upgrade]');
      // Show a precise upgrade only when the selected size or every available size has a single price.
      const canUpgrade = state.pack === 3 && current.available && quotes[4].available && !current.varies && !quotes[4].varies && quotes[4].variant.price >= current.variant.price;
      upgrade.hidden = !canUpgrade;
      if (canUpgrade) {
        const replacements = {difference:money(quotes[4].variant.price-current.variant.price),price:label(quotes[4])};
        root.querySelector('[data-upgrade-copy]').textContent = tokens(strings.upgrade,replacements);
        root.querySelector('[data-upgrade-action]').textContent = tokens(strings.upgradeAction,replacements) + ' →';
      }
      const replacements = Object.fromEntries(['one','two','three','four'].map((word,i) => [word + '_price',label(quotes[i+1])]));
      root.querySelectorAll('[data-price-copy]').forEach(node => node.textContent = tokens(node.dataset.copy,replacements));
      root.querySelector('[data-preview]').textContent = state.variant ? fill(strings.button, {PRICE:label(current)}) : strings.prompt;
      root.querySelector('[data-selected-quantity]').value = 1;
      root.querySelector('[data-selected-variant]').value = state.variant || '';
      root.querySelector('[data-selected-variant]').disabled = !state.variant;
      root.querySelector('[data-preview]').disabled = !current.available;
    }
    root.querySelectorAll('[data-pack]').forEach(button => button.addEventListener('click', () => {state.pack = Number(button.dataset.pack);result.hidden = true;render();}));
    root.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => {state.size = button.dataset.sizeName;result.hidden = true;render();}));
    root.querySelector('[data-upgrade]').addEventListener('click', () => {state.pack = 4;result.hidden = true;render();});
    root.querySelector('.ssm-order-form').addEventListener('submit', event => {
      if (!state.variant) {
        event.preventDefault();
        result.hidden = false;
        result.textContent = strings.prompt;
        root.querySelector('[data-size]:not(:disabled)')?.focus();
        return;
      }
      const button = root.querySelector('[data-preview]');
      button.disabled = true;
      button.textContent = strings.adding;
    });
    window.addEventListener('pageshow', render);
    render();
  }
  document.querySelectorAll('[data-mystery-drop]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mystery-drop]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
